import { render, staticRenderFns } from "./ForbiddenKeywordsTable.vue?vue&type=template&id=67e39b10&scoped=true"
import script from "./ForbiddenKeywordsTable.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e39b10",
  null
  
)

export default component.exports